import React from 'react'
import { useBlockingSession } from '../../Hooks/Features/Inspectra/useBlockingSession'
import CommonGrid from '../CommonCompo/CommonGrid/CommonGrid'
import { useCheckBlocking } from '../../Hooks/Features/Inspectra/useCheckBlocking'

const BlockingSession = ({ projectChanged }) => {
    const { blockingSessionsCols, rowData, loader, filterValue } = useBlockingSession({ projectChanged })

    return (
        <div className="inspectra-widget-container p-2">
            <div className="d-flex justify-content-between align-items-center">
                <div className="inspectra-widget-header"> Blocking Session</div>
            </div>
            <div className="mt-2 w100" style={{ height: "400px", overflow: "auto" }}>
                <CommonGrid columns={blockingSessionsCols} data={[{ title: "", id: "all", children: rowData }]} loader={loader} headerHeight={50}  rowHeight={40}/>
            </div>
        </div>
    )
}

export default BlockingSession
